import classNames from 'classnames';

import { I18Text } from '../../i18Next/I18Text';
import classes from '../FRBWidget.module.scss';

export function FreeSpinsType({ spinsCount }: { spinsCount: number }) {
  const stringLength = String(spinsCount).length;

  return (
    <div className={classNames(classes.freeSpinsType, stringLength > 1 && classes.sm)}>
      <div className={classes.amount}>{spinsCount}</div>
      <div className={classes.text}>
        <I18Text i18nKey="frb.freeSpinsClaimed" />
      </div>
    </div>
  );
}
